/* eslint-disable max-len */
import { ButtonLooks, FontIcons, StandardButton } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import { Organization } from '../SubscriptionsDashboard';

const SUBSCRIPTION_HEADER_COPY = {
  buttonText: bfTranslate('Request Upgrade'),
  // eslint-disable-next-line max-len
  description: bfTranslate('All owners can track utilization of resources, storage, features, and integrations. If no Brandfolder-level plan limits are set, each Brandfolder is able to use up to the entire organization limits.'),
  descriptionTitle: bfTranslate('Subscription'),
  descriptionLink: {
    href: 'https://help.brandfolder.com/hc/en-us/articles/9536077541015',
    text: bfTranslate('Learn more about plan limits.')
  },
  emailBody: 'I\'d like to inquire about upgrading our subscription for',
  pageHeader: bfTranslate('Subscription Details for')
};

interface SubscriptionHeaderProps {
  organization: Organization;
}

const SubscriptionHeader: FunctionComponent<SubscriptionHeaderProps> = ({ organization }) =>
  <>
    <div className='subscription__header'>
      <h3 className='subscription__header--title'>
        {SUBSCRIPTION_HEADER_COPY.pageHeader}
        <a className='subscription__header--title' href={`/organizations/${organization.slug}`} target='_blank'>
          {' '}
          {organization.name}
        </a>
      </h3>
      <a
        className='request-upgrade-button'
        href={`mailto:support@brandfolder.com?subject=Upgrade Inquiry&body=${SUBSCRIPTION_HEADER_COPY.emailBody}${organization}.`}
        target='_blank'
      >
        <StandardButton endIcon={FontIcons.Plus} look={ButtonLooks.Primary} type='button'>
          {SUBSCRIPTION_HEADER_COPY.buttonText}
        </StandardButton>
      </a>
    </div>
    <div className='subscription__description'>
      <h2>{SUBSCRIPTION_HEADER_COPY.descriptionTitle} </h2>
      <p>
        {SUBSCRIPTION_HEADER_COPY.description}
        <a
          href={SUBSCRIPTION_HEADER_COPY.descriptionLink.href}
          target="_blank"
        >
          {' '}{SUBSCRIPTION_HEADER_COPY.descriptionLink.text}
        </a>

      </p>
    </div>
  </>;

export default SubscriptionHeader;
